import {
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
} from '@angular/core';
import { UserDAO } from '../../../core/services/dao/userDAO';
import { AffiliateDAO } from '../../../core/services/dao/affiliateDAO';
import { ContainsSubscriptions } from '../../../core/services/interfaces/contains-subscriptions';
import { Subscription } from 'rxjs/Rx';
import { unsubscribeFromAll } from '../../../core/pure-functions/rx-helper';
import { AuthService } from '../../../core/services/auth.service';
import { User } from 'anchor-shared/lib/model/entity/user';
import { AffiliateBannerConfig } from 'anchor-shared/lib/model/entity/affiliate';
import { ActivatedRoute } from '@angular/router';
import { AffiliateStatusService } from '../../../core/services/affiliate-status.service';

@Component({
  selector: 'app-affiliate-banner',
  templateUrl: './affiliate-banner.component.html',
  styleUrls: ['./affiliate-banner.component.scss'],
})
export class AffiliateBannerComponent
  implements OnInit, OnDestroy, ContainsSubscriptions
{
  @Input() isMobile: boolean = false;

  @Input() sidenav;

  subs: Subscription[] = [];
  user: User;
  affiliateConfig: AffiliateBannerConfig;
  currentUserIsAffiliate = false;
  authEventCompleted = false;
  affiliateBrandImg: string;
  anchorLogo: string = 'assets/image/anchor-logo-white.png';

  constructor(
    private readonly userDAO: UserDAO,
    private readonly affiliateDAO: AffiliateDAO,
    private readonly authService: AuthService,
    private route: ActivatedRoute,
    private readonly affiliateStatusService: AffiliateStatusService,
  ) {}

  ngOnInit(): void {
    this.listenForAuth();
    this.listenForConfigChange();
  }

  ngOnDestroy() {
    unsubscribeFromAll(this.subs);
  }

  routeIsDisplayable(): boolean {
    if (
      window.location.pathname === '/' ||
      window.location.pathname === '/home' ||
      window.location.pathname.includes('/charters/yacht-and-boat-rentals') ||
      window.location.pathname.includes('/charters/boat-and-yacht-rentals') ||
      window.location.pathname.includes('/rental-location-map') ||
      window.location.pathname.includes('/vessels/yacht-and-boat-rentals') ||
      window.location.pathname.includes('/customer/booking')
    ) {
      return true;
    }
    return false;
  }

  private listenForAuth(): void {
    const sub = this.authService
      .getSessionAuthenticatedSubject()
      .subscribe((loggedIn) => {
        this.authEventCompleted = true;
        if (loggedIn) {
          this.user = this.userDAO.getCurrentUser();
          this.currentUserIsAffiliate = this.userDAO.currentUserIs('Affiliate');
          if (this.currentUserIsAffiliate) {
            this.loadAffiliateConfig();
          }
        } else {
          this.currentUserIsAffiliate = this.userDAO.currentUserIs('Affiliate');
          if (this.currentUserIsAffiliate) {
            this.affiliateConfig = null;
          }
        }
        this.readQueryParams();
      });
    this.subs.push(sub);
  }

  private loadAffiliateConfig(): void {
    const sub = this.affiliateDAO.loadForUser().subscribe((config) => {
      this.affiliateConfig = config;
      this.setAnchorLogo(config);
      this.affiliateStatusService.currentValidVanity.next(config);
    });
    this.subs.push(sub);
  }

  private setAnchorLogo(config): void {
    if (config?.accentColor?.includes('fff')) {
      this.anchorLogo = 'assets/image/anchor-logo-white.png';
    } else {
      this.anchorLogo = 'assets/image/anchor-logo-gray.png';
    }
  }

  private listenForConfigChange(): void {
    const sub = this.affiliateStatusService.currentValidVanity.subscribe(
      (config) => {
        this.affiliateConfig = config;
        this.setAnchorLogo(this.affiliateConfig);
        this.setBrandImg(config);
      },
    );
    this.subs.push(sub);
  }

  private readQueryParams(): void {
    const params = this.route.snapshot.queryParams;
    if (params.affiliate) {
      this.affiliateStatusService.setAffiliate(params.affiliate);
    }
  }

  private setBrandImg(affiliateConfig: AffiliateBannerConfig) {
    if (affiliateConfig && affiliateConfig.logoPath !== null) {
      this.affiliateBrandImg = affiliateConfig.logoPath;
    } else if (affiliateConfig && affiliateConfig.profilePhoto) {
      this.affiliateBrandImg = affiliateConfig.profilePhoto;
    }
  }
}
